module.exports = __webpack_public_path__ + "img/managed-services-catalogue.c84bd6d.webp";